export default {
    // baseUrl: '/',
    // baseUrl: 'http://172.20.54.158:8083'
    baseUrl: 'http://www.riotlily.com/api'
}
